import { BackOfficeRfidBadgeOrderModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/rfid-badge-orders/back-office-rfid-badge-order.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoRfidBadgeOrderListEmspUserIdCell } from './emsp-bo-rfid-badge-order-list-emsp-user-id.cell';
import { EmspBoRfidBadgeOrderListEmspUserIdHeader } from './emsp-bo-rfid-badge-order-list-emsp-user-id.header';

export const EmspBoRfidBadgeOrderListEmspUserIdColumn: IdentifiedColumnDef<
  BackOfficeRfidBadgeOrderModel,
  BackOfficeRfidBadgeOrderModel['emspUser']['id']
> = {
  id: 'emspUserId',
  enableSorting: false,
  header: EmspBoRfidBadgeOrderListEmspUserIdHeader,
  cell: EmspBoRfidBadgeOrderListEmspUserIdCell,
};
